export default __webpack_public_path__ + "static/media/19.77b9686d.jpg";